export const supportedLocales = {
  en: 'English',
  es: 'Español - Spanish',
  fr: 'Français - French',
  ko: '한국어 - Korean',
  ja: '日本語 - Japanese',
  'zh-CN': '中文 - Chinese (Simplified)',
};

export const LAST_LANGUAGE_LOCAL_STORAGE_KEY = 'bridge/last-language';
